export default __webpack_public_path__ + "assets/clear-day.54288da6.svg";